const CategoryPage = (data) => {
    if (!window.eS || !data.categoryKey) return;

    // const generalInfo = window.phone ? { user_phone: window.phone } : {};
    const generalInfo = {};
    if (window.phone) generalInfo.user_phone = window.phone;
    if (window.email) generalInfo.user_email = window.email;
    
    window.eS('sendEvent', 'CategoryPage', {
        'CategoryPage': {          
            'categoryKey': String(data.categoryKey)
        },
        'GeneralInfo': {
            ...generalInfo
        }
        // "Tags": {
        //     "some_tags": [
        //         "gh",
        //         "a2"
        //     ],
        //     "some_tags1": [
        //         "4",
        //         "gg"
        //     ]
        // }
    });
}

export default CategoryPage;